module.exports = __webpack_public_path__ + "img/timon_colores.2b6dc88e.svg";